import React from "react";
import { Link } from "react-router-dom";
import "./CalendarPage.css"; 
// import IconSocalFurs from './SocalDate.jpg'

export default function CalendarPage() {


  return (


            <div className = "calendar-container">
                <div className = "calendar-embed-container">
                    <iframe
                    title="Furry Events Calendar"
                    src="https://calendar.google.com/calendar/embed?src=1cdf9a4e9629d0b119d4daaa0e8ad0cc4d490b3cf95d458b0bf7247e323fb05e%40group.calendar.google.com&ctz=America/Los_Angeles"
                    className="calendar-src"
                     frameBorder="0"
                    ></iframe>
                </div>

            

        </div>

         
  );
}
